const PageStruct = {
    id: 'launch',
    children: [{ id: 'launch', order: 1 }]
};

export default PageStruct;
